import HardwareSerializer from 'eflex/serializers/hardware';

export default class WebCamSerializer extends HardwareSerializer {}
